<template>
	<div>Historial</div>
</template>

<script>
export default {
	name: 'record',
};
</script>




// WEBPACK FOOTER //
// Record.vue?38790621